import axios from 'axios';

export const projectService = {
  rename(projectId, newName) {
    return axios.post('/api/projects/rename/', { IsFolder: true, ObjectID: projectId, ObjectType: 'fod', NewName: newName });
  }
};